import React, { useState } from 'react'
import { useResume } from '../ResumeProvider'
import { Button } from '../../../lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import { EditableHeading, newKey } from './common'
import VolunteerItem from './VolunteerItem'
import { EditorItemProvider } from './EditorItemProvider'
import { useTemplate } from '~/lib/pdf'
import { useTranslation } from '~/hooks/useTranslation'

const VolunteerEditor = () => {
  const { t } = useTranslation('VolunteerEditor')
  const { resumeDocument, setResumeDocument } = useResume()
  const [activeIndex, setActiveIndex] = useState(-1)
  const volunteer = resumeDocument?.volunteer || []

  const { editorFieldEnabled } = useTemplate()

  const addVolunteer = () => {
    const newIndex = volunteer?.length || 0
    const updatedVolunteer = [...volunteer, {}]

    setResumeDocument({ ...resumeDocument, volunteer: updatedVolunteer })
    setActiveIndex(newIndex)
  }

  if (!editorFieldEnabled('volunteer')) return null

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex flex-row">
        <EditableHeading
          title={t('leadership_and_activities')}
          description={t('leadership_and_activities_description')}
          settingName="volunteerHeading"
        />
      </div>
      <div className="pb-4 tracking-[0.024px]">
        {t('add_any_volunteer_positions')}
      </div>
      {volunteer.map((item, index) => {
        item.key = item.key || newKey()
        return (
          <div key={item.key}>
            <EditorItemProvider
              sectionName="volunteer"
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={item}
            >
              <VolunteerItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addVolunteer} className="max-w-min">
        {t('add_leadership_and_activities')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default VolunteerEditor
